import Typography from '@mui/material/Typography';
import { Ellipsis } from '@openx/components-core/lib/Ellipsis/Ellipsis.tsx';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import type { Columns, TableColumn } from '@openx/types/tableHelpers.ts';
import { toUTCDate } from '@openx/utils/lib/date.ts';
import { Link } from 'react-router';

import type {
  AssociatedAudienceTableRow,
  ConfirmationTableRow,
  LalConfirmationTableRowWithAudiences,
} from '../../../types.ts';
import { DateCell } from '../../SegmentsList/parts/DateCell.tsx';

import { LinkedAudiencesCell } from './components/LinkedAudiencesCell.tsx';
import { NameCell } from './components/NameCell.tsx';

const segmentNameColumn: TableColumn<ConfirmationTableRow | LalConfirmationTableRowWithAudiences> = {
  key: 'name',
  render: data => <NameCell data={data} />,
  title: 'Segment Name',
  disabled: true,
};

const linkedAudiencesColumn: TableColumn<ConfirmationTableRow | LalConfirmationTableRowWithAudiences> = {
  key: 'linked_audiences',
  render: ({ segment_audiences }) => {
    return <LinkedAudiencesCell count={segment_audiences.length} />;
  },
  title: 'Linked Audiences',
};

const audienceNameTableColumn: TableColumn<AssociatedAudienceTableRow> = {
  key: 'name',
  render: data => {
    return (
      <Link to={`/audiences/${data.id}?fallback=true`} target="_blank">
        <Typography
          variant="body1Bold"
          component="span"
          color="primary"
          data-test="segment-name"
          sx={{
            lineHeight: '22px',
          }}
        >
          <Ellipsis tooltip width="400px">
            {data.name}
          </Ellipsis>
        </Typography>
      </Link>
    );
  },
  title: 'Audience Name',
  disabled: true,
};

const audienceStatusTableColumn: TableColumn<AssociatedAudienceTableRow> = {
  key: 'status',
  render: ({ status }) => <StatusIndicator status={status} wrapperStyles={{ lineHeight: '22px' }} />,
  title: 'Status',
};

const tableLastModifiedColumn: TableColumn<ConfirmationTableRow | LalConfirmationTableRowWithAudiences> = {
  key: 'updated_date',
  render: ({ updated_date }) => <DateCell date={toUTCDate(updated_date)} />,
  title: 'Last Modified',
};

export const confirmationDialogTableColumns: Columns<ConfirmationTableRow | LalConfirmationTableRowWithAudiences> = [
  {
    ...segmentNameColumn,
    width: '55%',
  },
  {
    ...linkedAudiencesColumn,
    width: '22%',
  },
  {
    ...tableLastModifiedColumn,
    width: '17%',
  },
];

export const associatedAudiencesTableColumns: Columns<AssociatedAudienceTableRow> = [
  {
    ...audienceNameTableColumn,
    width: '70%',
  },
  {
    ...audienceStatusTableColumn,
    width: '15%',
  },
];
